module.exports = __webpack_public_path__ + "static/5-e503922ec5d4ff6123f4719c9c2a1dfe.png";